import { initLightIcons, initRegularIcons, initSolidIcons } from "./icons";

export function initIcons() {
  initLightIcons();
  initRegularIcons();
  initSolidIcons();
}
